import { CreativeEngine } from '@cesdk/cesdk-js';

export const createApplyFormatAsset = (engine: CreativeEngine) => async (asset: { meta: { aspectRatio: string }; id: string }) => {
  const { meta, id } = asset;

  if (!meta) {
    throw new Error('Asset does not have meta');
  }

  const aspectRatioArray = meta.aspectRatio.split(':');
  const aspectWidth = parseFloat(aspectRatioArray[0]);
  const aspectHeight = parseFloat(aspectRatioArray[1]);
  const decimal = aspectWidth / aspectHeight;
  const ratio = Number(decimal.toFixed(1));
  const page = engine.scene.getCurrentPage()!;
  const originalHeight = engine.block.getHeight(page);
  const originalWidth = engine.block.getWidth(page);
  const originalAspectRatio = originalWidth / originalHeight;
  const pageIds = engine.block.findByType('page');
  const scene = engine.scene.get()!;

  let newHeight;
  let newWidth;

  if (originalAspectRatio > ratio) {
    newHeight = originalHeight;
    newWidth = originalHeight * ratio;
  } else {
    newWidth = originalWidth;
    newHeight = originalWidth / ratio;
  }

  engine.block.resizeContentAware(pageIds, newWidth, newHeight);
  engine.block.setString(scene, 'scene/pageFormatId', id);
  // We currently need to update pageDimensions manually.
  engine.block.setFloat(scene, 'scene/pageDimensions/height', newHeight);
  engine.block.setFloat(scene, 'scene/pageDimensions/width', newWidth);
};
